import React, { Component } from "react";
import Typo from "@material-ui/core/Typography";
import LocationIcon from "@material-ui/icons/LocationOnOutlined";
import PhoneIcon from "@material-ui/icons/PhoneOutlined";
import '../galleryStyles.scss';

class ContactUs extends Component {
  render() {
    return (
      <div className="row mt-5 p-5 fadeUpAn">
        <div className="col-12 p-3 text-center">
          <Typo variant="h2" className="font-weight-bold text-center">
            تماس با ما
          </Typo>
        </div>
        <div className="col-4"></div>
        <div className="col-md-4 p-3 mt-5">
          <Typo variant="body2" className="text-center rtl">
            <LocationIcon />
            آدرس : قدوسی غربی ، نبش کوچه ۶ علیرضایی ، کلاب کودک گفتگو
          </Typo>
          <Typo variant="body2" className="text-center rtl mt-3">
            <PhoneIcon /> تلفن تماس : ۰۹۱۷۰۷۲۱۳۴۲
          </Typo>
        </div>
      </div>
    );
  }
}

export default ContactUs;
